import { useMemo } from 'react';
import Analytics from '../../services/analytics/Analytics';

export default function useAnalytics() {
  return useMemo(
    () => ({
      track: (event, properties) => Analytics.track(event, properties),
      identify: (userId, traits) => Analytics.identify(userId, traits),
      register: (properties) => Analytics.register(properties),
      unregister: (propertyName) => Analytics.unregister(propertyName),
      reset: () => Analytics.reset(),
    }),
    [],
  );
}
